import EventEmitter from "../utils/EventEmitter";
import dispatcher from "../dispatcher";
import { Vector3 } from "../../libs/THREE.Vector3";
import TweenMax from "gsap/all";

var eventEmitter = new EventEmitter();
var color = null;
var defaultColor = null;
var locked = false;
var changing = false;

function hexToRgb(hex) {
  var result;

  result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? new Vector3(
        parseInt(result[1], 16) / 255,
        parseInt(result[2], 16) / 255,
        parseInt(result[3], 16) / 255,
      )
    : new Vector3(0, 0, 0);
}

var lastColor = null;

var colors = ["purple", "blue", "green", "red", "cyan", "sapphire"];

var mix = {
  blue: 0,
  purple: 0,
  green: 0,
  red: 0,
  cyan: 0,
  sapphire: 0,
};

var gradientsHex = {
  purple: "#6a2383;#e1017a",
  blue: "#afd6d5;#603777",
  green: "#a0c519;#008c3f",
  red: "#c3142d;#f3ce11",
  cyan: "#00abbd;#37ab49",
  sapphire: "#207CBF;#2E2CA2",
};

var colorsHex = {
  purple: "#79408c",
  blue: "#6a93f4",
  green: "#63a334",
  red: "#cb383b",
  cyan: "#00abbd",
  sapphire: "#284faf",
};

var colorsRbg = {};
var gradientsRgb = {};

var resultColor = new Vector3();
var resultGradient = [new Vector3(), new Vector3()];

var w = [];

var _handleEvent = function (e) {
  function mixColors(color, speed, value, update) {
    var tween = {};

    if (update) {
      tween.onUpdate = function () {
        var id;

        resultColor.set(0, 0, 0);
        resultGradient[0].set(0, 0, 0);
        resultGradient[1].set(0, 0, 0);

        colors.forEach(function (colorId) {
          resultColor.add(
            colorsRbg[colorId].clone().multiplyScalar(mix[colorId]),
          );
          resultGradient[0].add(
            gradientsRgb[colorId][0].clone().multiplyScalar(mix[colorId]),
          );
          resultGradient[1].add(
            gradientsRgb[colorId][1].clone().multiplyScalar(mix[colorId]),
          );
        });
      };
      tween.onComplete = function () {
        setTimeout(function () {
          changing = false;
        }, 20);
      };
    }

    changing = true;

    tween[color] = value;
    tween.speed = speed;

    tween.ease = Power0.easeInOut;
    TweenMax.to(mix, speed, tween);
  }

  if (e.type === "color:lock") {
    locked = true;
  }
  if (e.type === "color:unlock") {
    locked = false;
  }

  if (locked) return;

  if (e.type === "color:change") {
    if (color === e.color) return;
    color = e.color;

    if (!lastColor) {
      mixColors(color, 0, 1, true);
    } else {
      mixColors(lastColor, 0.6, 0, false);
      mixColors(color, 0.6, 1, true);
    }

    lastColor = color;

    eventEmitter.dispatch();
  }
  if (e.type === "color:revert") {
    if (color === defaultColor) return;
    color = defaultColor;
    eventEmitter.dispatch();
  }
  if (e.type === "color:set-default") {
    if (defaultColor === e.color) return;
    defaultColor = e.color;
  }
};

var getData = function () {
  var gradientHex = gradientsHex[color]
    ? gradientsHex[color].split(";")
    : ["#000000", "#000000"];
  return {
    color: color,
    colorVec3: colorsRbg[color],
    colorHex: colorsHex[color],
    gradientHex: gradientHex,
    gradientVector3: [hexToRgb(gradientHex[0]), hexToRgb(gradientHex[1])],
    mix: mix,
    mixColor: resultColor,
    mixGradient: resultGradient,
    changing: changing,
  };
};

var _init = function () {
  var id;
  var g1, g2;

  colors.forEach(function (colorId) {
    colorsRbg[colorId] = hexToRgb(colorsHex[colorId]);

    g1 = gradientsHex[colorId].split(";")[0];
    g2 = gradientsHex[colorId].split(";")[1];

    g1 = hexToRgb(g1);
    g2 = hexToRgb(g2);

    gradientsRgb[colorId] = [g1, g2];
  });

  dispatcher.subscribe(_handleEvent);
};

_init();

export default {
  subscribe: eventEmitter.subscribe.bind(eventEmitter),
  unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
  getData: getData,
};
